module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-aichi-3-c94d3c9f49e3206add622ecd9cf8dbee.jpg";